import React, {useState} from 'react';
import Button from "@components/common/button/button";
import './collapsible.scss'
import TextField from "@components/common/textField/textField";
import ArrowRight from "@images/icons/arrow-right.svg";
import {graphql, navigate, useStaticQuery} from "gatsby";
import {GatsbyImage} from "gatsby-plugin-image";
import ButtonGatsbyImage from "@components/common/buttonGatsbyImage/buttonGatsbyImage";

const Collapsible = (props) => {

  const data = useStaticQuery(graphql`
    query {
      allIndustriesDataJson {
        edges {
          node {
            id
            industryUrl
            name
            src {
             childImageSharp {
                gatsbyImageData (
                  quality: 100,
                  outputPixelDensities: 2, 
                  placeholder: NONE,
                  backgroundColor: "#27304D"
                  height: 24
                  width: 24
                  )
                }
              }
            images {
              className
              description
              imageUrl {
              childImageSharp {
                gatsbyImageData (
                  quality: 100,
                  outputPixelDensities: 2, 
                  placeholder: NONE,
                  backgroundColor: "#27304D"
                  pngOptions: {quality: 100}
                  )
                }
              }
              pageUrl
              title
            }
          }
        }
      }
    }
  `)

  const [open, setOpen] = useState(false);

  const toggle = () => {
    setOpen(!open);
  };

  const industryData = Object.values(data.allIndustriesDataJson.edges);

  const industryJsonData = industryData.filter(industryData => industryData.node.name === props.label)

  const exploreIndustries = () => {
    navigate(industryJsonData[0].node.industryUrl);
  }

  return (
    <div className='collapsible'>
      <ButtonGatsbyImage
        style={{marginBottom: open ? '16px' : '0'}}
        label={props.label}
        start={props.icon}
        type={open ? 'rounded active' : 'rounded'}
        onClick={toggle}
      >
      </ButtonGatsbyImage>
      {open && (
        industryJsonData[0].node.images.map((image) =>
          <a
            style={{textDecoration: 'none'}}
            href={image.pageUrl}
            key={image.imageUrl}
            className={'homepage-is-wrapper__industry-section__image-wrapper__rows__card'}
          >
            <div className='homepage-is-wrapper__industry-section__image-wrapper__rows__card__img-gradient'>
              <GatsbyImage alt='industries' image={image.imageUrl.childImageSharp.gatsbyImageData} />
            </div>

            <div className='homepage-is-wrapper__industry-section__image-wrapper__rows__card__inner-text'>
              <TextField
                type='default'
                title={image.title}
                description={image.description}
              >
              </TextField>
            </div>
          </a>
        )
      )}

      {open && (
        <div className='collapsible__explore'>
          <Button
            key={industryJsonData[0].node.name}
            type='rounded'
            label={'Explore ' + industryJsonData[0].node.name}
            end={ArrowRight}
            onClick={() => exploreIndustries()}
          >
          </Button>
        </div>
      )}
    </div>
  );
};
export default Collapsible;